import React, { useEffect, useState } from 'react';
import { Button, Grid, Typography } from '@mui/material';
import _ from 'lodash';
import { useFormContext } from 'react-hook-form';
import Select from '../../select/Select';
import FormInput from '../../input/FormInput';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import { conditionOptions, criteriaOptions } from './select-options';
import { generateTestId } from '../../../../../../utils';

// Shows the UI for creating conditions for a tiered rule
// Condition specifies the "when"/"if" part of the rule
function TieredRuleCondition({ name, index, addCondition, remove, disabledOnEdit = false }) {
    const { watch, control } = useFormContext();

    const shouldShowAmountConditions = (criteria) => {
        const criteriaObj = criteriaOptions.find((c) => c.id === criteria);
        return !criteriaObj?.boolean;
    };

    const isBetweenCondition = watch(`${name}.condition`) === 'BETWEEN' || watch(`${name}.condition`) === 'BETWEEN_EXCLUSIVE_UPPER';

    let conditionColumnSize = 4;
    if (isBetweenCondition) {
        conditionColumnSize = 2;
    }

    // Make the criteria column larger if we're not showing amount conditions
    let criteriaColumnSize = 3;
    if (!shouldShowAmountConditions(watch(`${name}.criteria`))) {
        criteriaColumnSize = 5;
    }

    return (
        <Grid container spacing={2} alignItems="stretch" wrap="nowrap">
            <Grid item xs={criteriaColumnSize}>
                <Select name={`${name}.criteria`} props={{ label: 'Criteria', options: criteriaOptions, required: true, size: 'small', disabled: disabledOnEdit }} />
            </Grid>
            {shouldShowAmountConditions(watch(`${name}.criteria`)) && (
                <>
                    <Grid item alignItems="center" display="flex">
                        <Typography variant="body2" fontWeight="bold" textAlign="center">
                            is
                        </Typography>
                    </Grid>
                    <Grid item xs={conditionColumnSize}>
                        <Select name={`${name}.condition`} props={{ label: 'Condition', options: conditionOptions, required: true, size: 'small', disabled: disabledOnEdit }} />
                    </Grid>
                    <Grid item xs={2}>
                        <FormInput name={`${name}.amount`} props={{ label: 'Amount', required: true, variant: 'outlined', size: 'small', type: 'number', disabled: disabledOnEdit }} />
                    </Grid>
                    {isBetweenCondition && (
                        <>
                            <Grid item alignItems="center" display="flex">
                                <Typography variant="body2" fontWeight="bold" textAlign="center">
                                    and
                                </Typography>
                            </Grid>
                            <Grid item xs={2}>
                                <FormInput name={`${name}.amountUpper`} props={{ label: 'Amount', required: true, variant: 'outlined', size: 'small', type: 'number', disabled: disabledOnEdit }} />
                            </Grid>
                        </>
                    )}
                </>
            )}
            <Grid item xs={2} justifyContent="center" alignItems="center" flexDirection="row">
                <Button variant="outlined" color="secondary" size="small" disabled={index === 0 || disabledOnEdit} onClick={() => remove(index)} sx={{ minWidth: '30px', minHeight: '30px', marginRight: '5px', marginTop: '10px' }} data-testid={generateTestId(name, 'delete-btn')}>
                    <DeleteIcon />
                </Button>
                <Button variant="outlined" color="secondary" size="small" onClick={addCondition} sx={{ minWidth: '30px', minHeight: '30px', marginTop: '10px' }} data-testid={generateTestId(name, 'add-btn')} disabled={disabledOnEdit}>
                    <AddIcon />
                </Button>
            </Grid>
        </Grid>
    );
}

export default TieredRuleCondition;
